import { createContext, useState, useEffect, useContext } from "react"
import axios from "axios"

export const AuthContext = createContext()

// Create a custom hook to use the auth context
export const useAuth = () => {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider')
  }
  return context
}

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const token = localStorage.getItem("token")
    if (token) {
      // Set default authorization header for all axios requests
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
      
      // Verify token and get user data
      const verifyToken = async () => {
        try {
          const response = await axios.get("http://localhost:4000/api/users/me")
          setUser(response.data)
        } catch (error) {
          console.error("Token verification failed:", error)
          localStorage.removeItem("token")
          delete axios.defaults.headers.common['Authorization']
        } finally {
          setLoading(false)
        }
      }
      
      verifyToken()
    } else {
      setLoading(false)
    }
  }, [])

  const login = (userData, token) => {
    setUser(userData)
    localStorage.setItem("token", token)
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
  }

  const logout = () => {
    setUser(null)
    localStorage.removeItem("token")
    delete axios.defaults.headers.common['Authorization']
  }

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  )
}

